<template>
  <div>
      <banner-top :text="titletext"></banner-top>
      <div class="bg"></div>
      <div class="order">
        <div class="orderhead">
          <div>
            订单编号：{{res.order_no}}
          </div>
          <div class="red">{{res.current_state.state_detail}}</div>
        </div>
        <el-divider></el-divider>
        <div class="classDetail">
          <div class="classDetailImg">
            <img :src="res.order_detail.lecture.thumbnail" alt="">
          </div>
          <div class="classDetailDiv">
            <div>{{res.order_detail.lecture.title}}</div>
            <div class="gray margin">上课地点：{{res.order_detail.place.address}}</div>
            <div class="gray margin">上课日期：{{res.order_detail.day}}</div>
            <div class="gray margin">上课时间：{{res.order_detail.session.start}}-{{res.order_detail.session.end}}</div>
            <div class="num">
              <div class="red">￥{{res.order_detail.price}}</div>
              <div class="gray">数量×{{res.order_detail.amount}}</div>
            </div>
          </div>
        </div>
        <div class="centerBg"></div>
        <div>
            <div class="information">
              <div class="addStudent">
                <div>学生信息</div>
              </div>
            </div>
            <el-divider></el-divider>
            <div v-for="item in res.order_detail.students" :key="item.id">
              <div class="student">
                <div style="font-size: 18px;">{{item.name}}</div>
                <div class="content">
                  {{item.school}},
                  {{item.classroom}}，
                  {{item.gender==1?'男': '女'}}，
                  联系电话{{item.phone}}，
                  身份证号{{item.id_no}}
                </div>
              </div>
            </div>
            <div style="height: 0.2rem;"></div>
        </div>
        <div class="centerBg"></div>
        <div>
            <div class="information">
              <div class="addStudent">
                <div>基本信息</div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="remark">
                <div>总金额：￥{{res.order_detail.total}}</div>
                <div>创建时间：{{res.created}}</div>
                <div :class="res.current_state.state_code =='cancelled'?'':'none'" >取消时间: {{res.states[res.states.length-1].created}}</div>
                <div :class="res.current_state.state_code =='refunding'?'':'none'" >退款理由: {{res.states[res.states.length-1].reason}}</div>
                <div :class="res.current_state.state_code =='refunded'?'':'none'" >退款时间: {{res.states[res.states.length-1].created}}</div>
                <div :class="res.current_state.state_code =='refunded'?'':'none'" >退款理由: {{res.states[res.states.length-1].reason}}</div>
                <div :class="res.current_state.state_code =='paid'?'':'none'" >支付方式：微信支付</div>
                <div :class="res.current_state.state_code =='paid'?'':'none'">支付时间：{{res.states[res.states.length-1].created}}</div>
                <div :class="res.current_state.state_code =='created'?'':'none'">支付剩余时间：{{setTime}}</div>
            </div>
            <div style="height: 3.5rem;background: #f5f5f5;"></div>
            <div class="nav checkButton gray">
                <div :class="res.current_state.state_code =='paid'?'':'none'" @click="toRegistration(res.order_no)">查看报名表</div>
                <div :class="res.current_state.state_code =='paid'?'':'none'" @click="open(res)">申请退款</div>
                <div :class="res.current_state.state_code =='created'?'':'none'" @click="pay(res.order_no, res.order_detail.total, res.created)">支付订单</div>
                <div :class="res.current_state.state_code =='created'?'':'none'" @click="close(res.order_no)">取消订单</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'orderDetail',
  components: { bannerTop },
  data () {
    return {
      checked: false,
      checked1: false,
      titletext: '订单详情',
      res: Object,
      myTime: null,
      setTime: ''
    }
  },
  created () {
    http['get'](`orders/${this.$route.query.order_no}`).then((res) => {
      this.res = res
      let mytime = res.current_state.created
      let dateTmp = mytime.replace(/-/g, '/')
      let timestamp = Date.parse(dateTmp)
      let newDate = new Date().getTime()
      timestamp = timestamp + 1000 * 60 * 15
      let ifdate = timestamp - newDate
      console.log(ifdate)
      ifdate = ifdate / 1000
      console.log(ifdate)
      if (ifdate < 0) {
        this.setTime = ''
      } else {
        return new Promise((resolve, reject) => {
          this.setTime = parseInt(ifdate / 60) + ':' + parseInt(ifdate % 60)
          this.myTime = setInterval(() => {
            ifdate = ifdate - 1
            this.setTime = parseInt(ifdate / 60) + ':' + parseInt(ifdate % 60)
            if (ifdate < 0) {
              clearInterval(this.myTime)
              this.myTime = null
              this.setTime = '已自动取消订单'
              resolve()
            }
          }, 1000)
        })
      }
    })
  },
  methods: {
    toRegistration: function (id) {
      this.$router.push({name: 'registration', query: {order_no: id}})
    },
    close (id) {
      this.$confirm('确定要取消订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '我再想想',
        center: true,
        customClass: 'winClass'
      }).then(() => {
        http['post'](`orders/${id}/cancel`).then((res) => {
        })
        http['get'](`orders/${this.$route.query.order_no}`).then((res) => {
          this.res = res
        })
        this.$message({
          type: 'success',
          message: '取消成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '未取消订单'
        })
      })
    },
    pay (id, detail, created) {
      this.$router.push({name: 'pay', query: {order_no: id, detail: detail, created: created}})
    },
    open (item) {
      let mytime = item.current_state.created
      let startTime = `${item.order_detail.day} ${item.order_detail.session.start}`
      let dateTmp = mytime.replace(/-/g, '/')
      let startTmp = startTime.replace(/-/g, '/')
      let timestamp = Date.parse(dateTmp)
      let start = Date.parse(startTmp)
      let newDate = new Date().getTime()
      let ifdate = timestamp - newDate
      ifdate = ifdate + 1000 * 60 * 60 * 24 * 7
      if (newDate > start) {
        this.$confirm('已经过了上课时间，无法申请退单', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'winClass',
          center: true
        })
      } else if (ifdate > 0) {
        this.$prompt('确定要申请退款？报名后7天内可以申请退单，超过7天无法申请退单。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '我再想想',
          center: true,
          customClass: 'winClass',
          inputPlaceholder: '请输入退款理由'
        }).then(({ value }) => {
          http['post'](`orders/${item.order_no}/refund`, {reason: value}).then((res) => {
          })
          http['get']('orders').then((res) => {
            this.res = res
          })
          this.$message({
            type: 'success',
            message: '申请成功!'
          })
          this.$router.go(0)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        this.$confirm('报名已经超过7天，无法申请退单', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          customClass: 'winClass',
          center: true
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.order {
  background: #fff;
}
.orderhead {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
.el-divider{
   margin: 0;
}
.classDetail {
  margin-top: 1rem;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.8rem;
}
.classDetailImg {
  height: 6rem;
  width: 6rem;
  overflow: hidden;
  margin-left: 0.8rem;
}
.classDetailImg img{
  height: 6rem;
  transform: translateX(-50%);
  margin-left: 50%;
}
.classDetailDiv {
  flex: 2;
  margin: 0 0.6rem ;
}
/* .classDetailImg img{
  width: 6rem;
  margin-left: 0.6rem;
}
.classDetailDiv {
  margin-right: 2rem;
} */
.gray {
  color: #666;
}
.red {
  color: #ff0000;
}
.margin {
  margin: 0.3rem 0;
}
.num {
  display: flex;
  justify-content: space-between;
}
.information {
  margin: 0.8rem;
  color: #000;
  font-size: 20px;
}
.student {
  margin: 0.8rem;
  border-radius: 10px;
  background: #f5f5f5;
  padding: 0.8rem;
}
.addStudent {
  margin: 0.3rem;
  display: flex;
  justify-content: space-between;
}
.content {
  color: #666;
  word-break: break-all;
  word-wrap: break-word
}
.centerBg {
  width: 100%;
  height: 1rem;
  background: #f5f5f5;
}
.remark {
    margin: 1rem;
}
.remark div{
    margin: 0.1rem 0;
    font-size: 14px;
}
.nav {
  width: 100%;
  height: 3rem;
  display: flex;
  position:fixed;
  bottom: 0;
  background: #fff;
}
.none {
  display: none;
}
.checkButton {
  display: flex;
  justify-content: flex-end;
}
.checkButton div {
  border: #999 1px solid;
  border-radius: 27px;
  height: 2rem;
  line-height: 2rem;
  padding: 0.1rem 0.4rem;
  margin-right: 0.5rem;
  margin-top: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/order/orderDetail.vue